import { IDashExtServerSettings } from '../../../../types/IEditableServerSettings';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../../../../httpClient/serverApi/requests/Request';

export interface IUpdateExtensionsServerSettingsParams {
  settings: IDashExtServerSettings;
}

export type IUpdateExtensionsServerSettingsResult = IResult & IDashExtServerSettings;

export class UpdateExtensionsServerSettingsRequest extends Request<IUpdateExtensionsServerSettingsParams, IUpdateExtensionsServerSettingsResult> {
  constructor(params: IUpdateExtensionsServerSettingsParams) {
    super('updateExtensionsServerSettings', params);
  }
}
